import React from 'react';

export const CityIcon = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_581_442)">
                <path
                    d="M5.5 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5L0 12H7V1.5C7 1.10218 6.84196 0.720644 6.56066 0.43934C6.27936 0.158035 5.89782 0 5.5 0ZM3 9.5H1.5V8.5H3V9.5ZM3 7.5H1.5V6.5H3V7.5ZM3 5.5H1.5V4.5H3V5.5ZM3 3.5H1.5V2.5H3V3.5ZM5.5 9.5H4V8.5H5.5V9.5ZM5.5 7.5H4V6.5H5.5V7.5ZM5.5 5.5H4V4.5H5.5V5.5ZM5.5 3.5H4V2.5H5.5V3.5ZM10.5 2.5H8V12H12V4C12 3.60218 11.842 3.22064 11.5607 2.93934C11.2794 2.65804 10.8978 2.5 10.5 2.5ZM10.5 9.5H9.5V8.5H10.5V9.5ZM10.5 7.5H9.5V6.5H10.5V7.5ZM10.5 5.5H9.5V4.5H10.5V5.5Z"
                    fill="currentColor"/>
            </g>
            <defs>
                <clipPath id="clip0_581_442">
                    <rect width="12" height="12" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}